
import { defineComponent } from '@vue/composition-api';
import {
  FCButton,
} from '@fc/angie-ui';
import SplitView from '~/components/SplitView.vue';
import { useModal } from '~/composables/useModal';

export default defineComponent({
  name: 'MembersSection',
  components: {
    SplitView,
    FCButton,
  },
  setup() {
    const handleKellieVideo = () => {
      const { modalShow } = useModal({
        component: () => import('~/components/v5/VideoDialog.vue'),
        componentProps: {
          videoUrl: 'https://www.youtube.com/embed/F4DMiyk7t8E?autoplay=1',
          videoId: 'kellie-frederick-transformation',
          isEmbed: true,
        },
        modalProps: {
          componentName: 'VideoDialog',
          width: '90%',
          maxWidth: 1200,
          height: 'auto',
          reset: true,
          classes: 'modal-border-radius',
        },
      });

      modalShow();
    };

    return {
      handleKellieVideo,
    };
  },
});
